import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import Textarea from '@/components/ui/Textarea';
import Button from '@/components/ui/Button';
import ImageUpload from '@/components/ui/ImageUpload';
import {
  MUSCLE_GROUPS, MUSCLE_LABELS, EQUIPMENT, EQUIPMENT_LABELS,
  DIFFICULTY, DIFFICULTY_LABELS, optsFrom,
} from '@/lib/enums';

const empty = {
  name: '', muscleGroup: 'peito', equipment: 'nenhum', difficulty: 'iniciante',
  imageUrl: '', videoUrl: '', instructions: '', tips: '',
};

/** Form de exercício reutilizado por admin (global) e trainer (próprio). */
export default function ExerciseForm({ initial, onSubmit, onCancel }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ ...empty, ...initial });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setErr(t('exercises.errName'));
    setSaving(true);
    setErr(null);
    try {
      await onSubmit(form);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <Input label={t('exercises.fieldName')} value={form.name} onChange={set('name')} placeholder={t('exercises.namePlaceholder')} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 'var(--space-3)' }}>
        <Select label={t('exercises.fieldMuscleGroup')} value={form.muscleGroup} onChange={set('muscleGroup')}
          options={optsFrom(MUSCLE_GROUPS, MUSCLE_LABELS)} />
        <Select label={t('exercises.fieldEquipment')} value={form.equipment} onChange={set('equipment')}
          options={optsFrom(EQUIPMENT, EQUIPMENT_LABELS)} />
        <Select label={t('exercises.fieldDifficulty')} value={form.difficulty} onChange={set('difficulty')}
          options={optsFrom(DIFFICULTY, DIFFICULTY_LABELS)} />
      </div>
      <ImageUpload
        label={t('exercises.fieldImage')}
        folder="exercises"
        value={form.imageUrl}
        onChange={(url) => setForm((f) => ({ ...f, imageUrl: url }))}
      />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
        <Input label={t('exercises.fieldImageUrl')} value={form.imageUrl} onChange={set('imageUrl')} placeholder="https://..." />
        <Input label={t('exercises.fieldVideoUrl')} value={form.videoUrl} onChange={set('videoUrl')} placeholder="https://..." />
      </div>
      <Textarea label={t('exercises.fieldInstructions')} value={form.instructions} onChange={set('instructions')} rows={3} />
      <Textarea label={t('exercises.fieldTips')} value={form.tips} onChange={set('tips')} rows={2} />
      {err && <span style={{ color: 'var(--danger)', fontSize: 13 }}>{err}</span>}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <Button type="button" variant="ghost" onClick={onCancel}>{t('common.cancel')}</Button>
        <Button type="submit" loading={saving}>{t('common.save')}</Button>
      </div>
    </form>
  );
}
